import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { HomePage } from "./pages/home/HomePage";
import { RootLayout } from "./layouts/RootLayout";
import { UploadPage } from "./pages/upload/UploadPage";
import { PhotoCompPage } from "./pages/photo_comp/PhotoCompetition";
import { SweaterCompPage } from "./pages/sweater_comp/SweaterCompetition";
import { VotingPage } from "./pages/voting/VotingPage";
import { AppProvider } from "./context/AppProvider";
import { UserPage } from "./pages/user_page/UserPage";
import { DiagPage } from "./pages/diagnostics/DiagPage";
import { TeamPage } from "./pages/team_setup/TeamPage";
import { RaceVotingPage } from "./pages/voting/RaceVotingPage";
import { RaceResultsPage } from "./pages/voting/RaceResultsPage";

const router = createBrowserRouter([
  {
    path: "/",
    //element: <RootLayout />,
    children: [
      {
        index: true,
        element: <UploadPage />,
      },
      {
        path: "admin",
        element: <h1>Admin Console</h1>,
      },
      {
        path: "user",
        element: <UserPage />,
      },
      {
        path: "team",
        element: <TeamPage />,
      },
      {
        path: "voting",
        element: <RaceVotingPage />,
      },
      {
        path: "diag",
        element: <DiagPage />,
      },
      {
        path: "results",
        element: <RaceResultsPage />,
      },

      {
        path: "app",
        element: <UploadPage />,
        children: [
          {
            path: "sendtool/:upload_id",
            element: <UploadPage />,
          },
        ],
      },
      /*
      {
        path: "photo-comp",
        element: <PhotoCompPage />,
      },
      {
        path: "sweater-comp",
        element: <SweaterCompPage />,
      },
      {
        path: "voting",
        element: <VotingPage />,
      },
      {
        path: "mod",
        element: <h1>...</h1>,
        children: [
          {
            path: "approve",
            element: <HomePage />,
          },
          {
            path: "results",
            element: <HomePage />,
          },
        ],
      },*/
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  </React.StrictMode>,
);
